export function getSubdomain(): string | null {
  const hostname = window.location.hostname;

  // localhost (no subdomain)
  if (hostname === 'localhost' || hostname === '127.0.0.1') return null;

  // acme.localhost → "acme"
  if (hostname.endsWith('.localhost')) {
    return hostname.split('.')[0] ?? null;
  }

  // IP address (e.g. 192.168.0.191) — no subdomain
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return null;

  // acme.sindian.app → "acme"
  // sindian.app → null
  // www.sindian.app → null
  const parts = hostname.split('.');
  if (parts.length <= 2) return null;
  if (parts[0] === 'www') return null;
  return parts[0] ?? null;
}

export function isMarketingSite(): boolean {
  return getSubdomain() === null;
}

export function isTenantSite(): boolean {
  return getSubdomain() !== null;
}
